import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as PlusRoundedSvg } from './assets/plus-rounded.svg';

const PlusRoundedIcon = React.forwardRef((args, ref) => <SvgIcon component={PlusRoundedSvg} ref={ref} {...args} />);

export default PlusRoundedIcon;
